

export const search_and_users_mixin = {
  data: () => ({
    all_users: [
      { name: 'Mashudu Mphaphuli', email: 'mashudu@epftechhubic.org' },
      { name: 'Jane Doe', email: 'jane@example.com' },
      { name: 'John Smith', email: 'john@example.com' }
    ],
    selected_users: [],
    search_timeouts: null
  }),

  methods: {
    // Debounce search function
    debounce_search(func, wait) {
      let timeout;
      return function executed_function(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },

    // Filter users based on search term
    filter_users(status_reviewer, search_term = '') {
      if (!search_term.trim()) {
        return status_reviewer.available_users;
      }

      const term = search_term.toLowerCase();
      return status_reviewer.available_users.filter(user => {
        const full_name = `${user.first_name || ''} ${user.last_name || ''}`.toLowerCase();
        return full_name.includes(term) ||
          user.email?.toLowerCase().includes(term) ||
          user.first_name?.toLowerCase().includes(term) ||
          user.last_name?.toLowerCase().includes(term);
      });
    },

    // Handle search input with debouncing
    on_search_input(status_reviewer, search_term, status_index, reviewer_index) {
      status_reviewer.user_search = search_term;
      const timeout_key = `status_${status_index}_reviewer_${reviewer_index}`;
      if (!this.search_timeouts || typeof this.search_timeouts !== 'object') {
        this.search_timeouts = Object.create(null);
      }
      if (Reflect.has(this.search_timeouts, timeout_key)) {
        clearTimeout(Reflect.get(this.search_timeouts, timeout_key));
        Reflect.deleteProperty(this.search_timeouts, timeout_key);
      }
      const timeout_id = setTimeout(() => {
        status_reviewer.filtered_users = this.filter_users(status_reviewer, search_term);
      }, 300);

      Reflect.set(this.search_timeouts, timeout_key, timeout_id);
    }
  }
};